// https://vue-sonner.vercel.app/

import { toast } from "vue-sonner";

export const toaster = {
  success(message, options = {}) {
    return toast.success(message, {
      duration: 3000,
      ...options,
      ...(options.duration === Infinity && { closeButton: true }),
    });
  },

  error(message, options = {}) {
    return toast.error(message, {
      duration: 5000,
      ...options,
      ...(options.duration === Infinity && { closeButton: true }),
    });
  },

  info(message, options = {}) {
    return toast(message, {
      duration: 4000,
      ...options,
      ...(options.duration === Infinity && { closeButton: true }),
    });
  },

  warning(message, options = {}) {
    return toast(message, {
      duration: 4000,
      ...options,
      ...(options.duration === Infinity && { closeButton: true }),
    });
  },

  promise(promiseFn, messages) {
    return toast.promise(promiseFn, messages);
  },

  dismiss(toastId) {
    return toast.dismiss(toastId);
  },

  // Expose raw toast for custom needs
  toast,
};
